import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.ProductCategory.Delete.IRequest;
type Response = Api.Core.ProductCategory.Delete.IResponse;
type Headers = Api.Core.ProductCategory.Delete.IHeaders;
const url = '/api/ProductManagement/ProductCategory/:id';
export default async function productCategoryDeleteApi(id: number): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.delete,
    url: createPathFromRoute(url, { id }),
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
